import { type Promotion, AwardsEnum } from "@b2bportal/hsbc-promotions-api";

// TODO: should be in promotions api
const MILES_EARNED_PER_DOLLAR = 2.5;
const POINTS_PER_MILE = 2.5;

export const getMilesEarnedPerDollar = (promotion: Promotion) => {
  if (promotion.awards.Awards === AwardsEnum.MilesEarnWithMultiplier) {
    return promotion.awards.multiplier * MILES_EARNED_PER_DOLLAR;
  }
  return MILES_EARNED_PER_DOLLAR;
};

export const getPointsEarnedPerDollar = (promotion?: Promotion) => {
  if (!promotion) {
    return 0;
  }

  return getMilesEarnedPerDollar(promotion) * POINTS_PER_MILE;
};
